import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Equipment } from "@/components/site/Equipment";
import { WhyUs } from "@/components/site/WhyUs";
import { Banner } from "@/components/site/Banner";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { runEntryBurst } from "@/lib/brandFx";

export default function Landing() {
  useEffect(() => {
    runEntryBurst();
  }, []);

  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <BeforeAfter />
        <Equipment />
        <WhyUs />
        <Banner />
        <ServiceArea />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
